import React, { Component } from "react"
import Svg from "../_svgs/svg"
import * as date from "../../booking/helpers/date"
import * as SelectionFactoryHelper from "../helpers/SelectionFactoryHelper"
import * as axios from "axios"
import ReactHtmlParser from "react-html-parser"
import * as endpoint from "../../booking/constants/Endpoints"
import { DateTime } from "luxon"
import { trackTravelPlanner, trackTravelPlannerInteraction, handleEvalTracking } from "../../helpers/tracking"
import * as IsoHelper from "../../helpers/IsoDateHelpers"

export class ItineraryCheckIn extends Component {
  constructor(props) {
    super(props)

    this.state = {
      block: props.block,
      flightInfo: props.flightInfo,
      airlinesPageLink: props.airlinesPageLink,
      awaitingLabel: props.awaitingLabel,
      closedLabel: props.closedLabel,
      awaitingClosedLabel: props.awaitingClosedLabel,
      hidePastSteps: props.hidePastSteps,
      showSignupBox: undefined,
      profile: props.profile,
      isLoggedIn: props.isLoggedIn,
      travelInformation: props.travelInformation,
      checkedInBaggage: undefined,
      flightCheckInCounterResume: undefined,
    }

    this.renderContentBlocks = this.props.renderContentBlocks.bind(this)
    this.showHideContent = this.props.showHideContent.bind(this)

    this.showSignupModal = this.props.showSignupModal.bind(this)
    this.checkInRef = React.createRef()
    this.setFlightCheckInCounterResume()
  }

  componentDidMount() {
    var hash = window.location.hash
    if (hash) {
      if (hash === "#checkin-changed" || hash === "#new-checkin") {
        this.checkInRef.current.scrollIntoView({
          behavior: "smooth",
        })
      }
    }
    if (this.state.profile && Object.keys(this.state.profile).length > 0) {
      this.setState({ isLoggedIn: true }, () => {
        this.showFollowFlightSignupBox()
        this.hasCheckedInBaggage()
      })
    } else {
      this.setState({
        showSignupBox: true,
      })
    }
  }

  componentDidUpdate() {
    if (this.state.travelInformation !== this.props.travelInformation) {
      this.setState({ travelInformation: this.props.travelInformation }, () => {
        this.showFollowFlightSignupBox()
        this.hasCheckedInBaggage()
      })
    }
  }

  showFollowFlightSignupBox() {
    if (this.props.travelInformation && this.props.travelInformation.length > 0) {
      for (let i = 0; i < this.props.travelInformation.length; i++) {
        if (this.props.travelInformation[i].Registration_Source__c === "Follow Flight") {
          this.setState({ showSignupBox: false })
          return
        }
      }
    }
    this.setState({ showSignupBox: true })
  }

  setFlightCheckInCounterResume = () => {
    if (!this.state.flightInfo.flightCheckInCounterResume) {
      const hosts = document.body && document.body.dataset.hosts && JSON.parse(document.body.dataset.hosts)

      if (this.state.flightInfo && !this.state.flightInfo.flightCheckInCounterResume) {
        axios
          .get(endpoint.FLIGHT_INFO(hosts, this.state.flightInfo.RecordId))
          .then((res) => res.data)
          .then((data) => {
            if (data && data.flightCheckInCounterResume && this.state.flightCheckInCounterResume !== data.flightCheckInCounterResume) {
              this.setState({ flightCheckInCounterResume: data.flightCheckInCounterResume })
            }
          })
          .catch((err) => {
            console.log("something went wrong: " + err)
          })
      }
    }
  }

  hasCheckedInBaggage() {
    if (this.props.travelInformation && this.props.travelInformation.length > 0) {
      for (let i = 0; i < this.props.travelInformation.length; i++) {
        const element = this.props.travelInformation[i]
        if (element.Registration_Source__c === "Travel Guide" && element.travels_with_check_in_baggage__c) {
          this.setState({ checkedInBaggage: true })
          return
        }
      }
    }
  }

  handleAccordionClick = (e) => {
    this.showHideContent(e, ".contentWrapper")
    this.handleAccordionTracking()
  }

  handleAccordionTracking = () => {
    this.setState({ accordionOpen: !this.state.accordionOpen }, () => {
      if (this.state.accordionOpen) {
        trackTravelPlannerInteraction(this.props.tabToggle, "fold_open", { fold_title: this.props.block.heading })
      } else {
        trackTravelPlannerInteraction(this.props.tabToggle, "fold_close", { fold_title: this.props.block.heading })
      }
    })
  }

  handleSignUpTerminalClick = () => {
    this.showSignupModal("check-in terminal")
    trackTravelPlanner("track-event.generic", "follow flight - click", "check-in terminal", this.state.flightInfo.FlightId)
  }

  handleSignUpCountersClick = () => {
    this.showSignupModal("check-in counter")
    trackTravelPlanner("track-event.generic", "follow flight - click", "check-in counter", this.state.flightInfo.FlightId)
  }

  getCheckInCounterMarkup = (counterInfo) => {
    return counterInfo.map((info, index) => (
      <p key={index} className={"counterStyle"}>
        {info} <br />
      </p>
    ))
  }

  formatCheckInTimeFrame = (startDateTime, endDateTime, flightDepartureDate) => {
    var startDateTimeObject = IsoHelper.getDateVarsObject(startDateTime)
    var flightDepartureDateObject = IsoHelper.getDateVarsObject(flightDepartureDate)
    var culture = this.state.flightInfo.language

    if (flightDepartureDateObject.day > startDateTimeObject.day) {
      if (culture === "da")
        return `${startDateTimeObject.day} ${IsoHelper.getRealMonth(startDateTimeObject.month, culture)}. ${startDateTimeObject.hour}:${
          startDateTimeObject.minute
        }`
      return `${IsoHelper.getRealMonth(startDateTimeObject.month, culture)} ${startDateTimeObject.day} ${startDateTimeObject.hour}:${
        startDateTimeObject.minute
      }`
    }

    return `${startDateTimeObject.hour}:${startDateTimeObject.minute}`
  }

  formatCheckInStartTime = (startDateTime, endDateTime) => {
    var startDateTimeObject = IsoHelper.getDateVarsObject(startDateTime)
    var endDateTimeObject = IsoHelper.getDateVarsObject(endDateTime)
    return `${startDateTimeObject.hour}:${startDateTimeObject.minute} - ${endDateTimeObject.hour}:${endDateTimeObject.minute}`
  }

  render() {
    const buttonSvg = SelectionFactoryHelper.getFromSelectionFactory(this.props.block.buttonIcon)
    const buttonColor = SelectionFactoryHelper.getFromSelectionFactory(this.props.block.buttonColor)
    const theme = SelectionFactoryHelper.getFromSelectionFactory(this.props.block.backgroundColor)
    const hasContentBlocksBeforeText = this.props.block.contentAreaBeforeText?.length > 0
    const hasContentBlocks = this.props.block.contentArea?.length > 0

    const dtLocale = date.luxonLocale(this.state.flightInfo.language)
    const zone = "Europe/Copenhagen"
    const scheduledTime = DateTime.fromISO(this.state.flightInfo.ScheduledTime).setLocale(dtLocale).setZone(zone)
    const checkInTime = scheduledTime.minus({ minutes: this.props.checkInOpens })
    const newLink = this.state.airlinesPageLink + "/" + this.state.flightInfo.IataCode
    const checkInCounters = this.state.flightInfo.CheckInCountersT3 ?? this.state.flightInfo.CheckInCountersT2
    const checkInRollOff =
      this.state.flightInfo.RollOffCheckIn === "1" ||
      this.state.flightInfo.PublicRemark === "Closed" ||
      (this.state.flightInfo.PublicRemark && !checkInCounters)
    const terminal = this.state.flightInfo.CheckInTerminal
    const counter = checkInCounters ?? (checkInRollOff ? this.state.closedLabel : this.props.currentPageJson.checkInCounterFallbackValue)
    const openingTime = this.state.flightInfo.ScheduledTime
      ? checkInTime.toFormat("HH:mm")
      : checkInRollOff
        ? this.state.closedLabel
        : this.state.awaitingClosedLabel
    const hasFocusContentBlocks = this.props.block.focusContentArea?.length > 0
    const showFocusContentBlocks =
      !checkInRollOff && !checkInCounters
        ? true
        : checkInRollOff
          ? false
          : !checkInCounters
            ? true
            : !this.state.flightInfo.CheckInTerminal
              ? true
              : false
    const blockText = this.state.travelInformation
      ? this.state.checkedInBaggage && this.state.checkedInBaggage && this.props.block.baggageTextYes
        ? this.props.block.baggageTextYes
        : this.props.block.text
      : this.props.block.text

    const signUpLinkTerminal = (
      <React.Fragment>
        <a className={"pointer"} onClick={this.props.currentPageJson.enableFollowFlight ? () => this.handleSignUpTerminalClick() : undefined}>
          {this.props.currentPageJson.enableFollowFlight ? this.props.block.checkInSignUpText || "(Tilmeld info)" : ""}
        </a>{" "}
        {terminal}
      </React.Fragment>
    )
    const signUpLinkCounter = (
      <React.Fragment>
        <a className={"pointer"} onClick={this.props.currentPageJson.enableFollowFlight ? () => this.handleSignUpCountersClick() : undefined}>
          {this.props.currentPageJson.enableFollowFlight ? this.props.block.checkInSignUpText || "(Tilmeld info)" : ""}
        </a>{" "}
        {counter}
      </React.Fragment>
    )

    //#region bettecheckin
    //bc = Better Check-In
    let counterResume //Full better check in object.
    let bcCheckInType //Type of counter for the flight

    let bcCheckInTimeFrame //Time window that counters are open, contains opening time + closing time.

    let bcPresentFlightCheckInCounterGroups //Bool check to validate better check in functionality.
    let bcFlightCheckInCounterGroups //Grouped counters for better check in elements

    let bcCheckInTimeStart //Moment counters open. Contains opening time.

    //Better Check-In Manipulation
    if (this.state.flightCheckInCounterResume) {
      //overall object
      counterResume = this.state.flightCheckInCounterResume

      //check-in type
      bcCheckInType = counterResume.checkInType

      bcPresentFlightCheckInCounterGroups =
        !!counterResume.flightCheckInCounterGroups &&
        counterResume.flightCheckInCounterGroups.length > 0 &&
        !!this.props.currentPageJson.enableBetterCheckIn
      bcFlightCheckInCounterGroups = this.getCheckInCounterMarkup(counterResume.flightCheckInCounterGroups)

      //date time manipulation.
      if (bcPresentFlightCheckInCounterGroups) {
        bcCheckInTimeFrame = this.formatCheckInTimeFrame(
          counterResume.firstCheckInTime,
          counterResume.lastCheckInTime,
          this.state.flightInfo.ScheduledTime,
        )
        bcCheckInTimeStart = this.formatCheckInStartTime(counterResume.firstCheckInTime, counterResume.lastCheckInTime)
      }
    }
    //#endregion

    let subheading = ""
    if (this.props.block.subHeading && this.state.flightInfo.CheckInTerminal && !checkInRollOff) {
      subheading = this.props.block.subHeading.replace("{terminal}", this.state.flightInfo.CheckInTerminal)
    } else {
      subheading = terminal
    }
    if (this.props.currentPageJson.terminal2Label && this.props.currentPageJson.terminal3Label)
      subheading =
        subheading === "T2"
          ? subheading.replace("T2", this.props.currentPageJson.terminal2Label)
          : subheading === "T3"
            ? subheading.replace("T3", this.props.currentPageJson.terminal3Label)
            : subheading

    const style = { "--itinerary-icon": `url(${this.props.block.itineraryIcon ? this.props.block.itineraryIcon : ""})` }

    return (
      <div
        ref={this.checkInRef}
        style={this.props.block.itineraryIcon ? style : undefined}
        className={`departure-info__essentials__detailitems__detailitem ${theme ? theme : ""} foldable`}
      >
        <div className={"departure-info__essentials__detailitems__detailitem__header pointer"} onClick={(e) => this.handleAccordionClick(e)}>
          <div className="floatbox">
            <div>{bcPresentFlightCheckInCounterGroups ? bcCheckInTimeFrame : openingTime}</div>
          </div>
          <h5>{this.props.block.heading}</h5>
          {subheading ? <h6>{subheading}</h6> : ""}
        </div>
        <div className={"contentWrapper show-hide"}>
          <div className={`departure-info__essentials__detailitems__detailitem__infobox`}>
            <div className="grid">
              <div className="grid-item col--12">
                <div className="info-text">{this.props.block.checkInTerminalLabel}</div>
                <h5 className={`${terminal ?? (checkInRollOff ? "" : "awaiting")}`}>
                  {checkInRollOff || this.state.flightInfo.CheckInTerminal ? terminal : signUpLinkTerminal}
                </h5>
              </div>
              <div className="grid-item col--12">
                <div className="info-text">{this.props.block.checkInDeskLabel}</div>
                <h5 className={`${checkInCounters ?? (checkInRollOff ? "" : "awaiting")}`}>
                  {bcPresentFlightCheckInCounterGroups
                    ? bcFlightCheckInCounterGroups
                    : checkInRollOff || checkInCounters
                      ? counter
                      : signUpLinkCounter}
                </h5>
              </div>
              <div className="grid-item col--12">
                <div className="info-text">
                  {bcPresentFlightCheckInCounterGroups
                    ? this.props.currentPageJson.betterCheckInOpensAtLabel || "Check-In"
                    : this.props.block.checkInOpeningTimeLabel}
                </div>
                <h5>{bcPresentFlightCheckInCounterGroups ? bcCheckInTimeStart : openingTime}</h5>
              </div>
            </div>
          </div>
          <div className="info-text">
            {bcPresentFlightCheckInCounterGroups && bcCheckInType === "Common"
              ? ReactHtmlParser(this.props.currentPageJson.betterCheckInInfoMessage) || ""
              : ""}
          </div>
          {hasContentBlocksBeforeText ? this.renderContentBlocks(this.props.block.contentAreaBeforeText) : ""}
          {blockText || this.props.block.buttonText ? (
            <div className={"textbuttoncontainer"}>
              {blockText ? <span className="rich-text" dangerouslySetInnerHTML={{ __html: blockText }}></span> : ""}
              {this.props.block.buttonText && this.props.block.buttonLink ? (
                <div className="cta-button">
                  <a
                    className={`button button--small button--general button__floatbox rm-this-class rm-this-class-hide-default ${
                      buttonColor ? buttonColor : "casc-blue"
                    }`}
                    href={this.props.block.linkToAirlineBool ? newLink : this.props.block.buttonLink}
                    onClick={() => handleEvalTracking(this.props.block.buttonTracking)}
                  >
                    {buttonSvg !== "" ? <Svg iconName={buttonSvg} /> : ""}
                    <span className="text">{this.props.block.buttonText}</span>
                  </a>
                </div>
              ) : (
                ""
              )}
            </div>
          ) : (
            ""
          )}
          {hasFocusContentBlocks && showFocusContentBlocks ? (
            <div>{this.renderContentBlocks(this.props.block.focusContentArea, this.state.showSignupBox)}</div>
          ) : (
            ""
          )}
          {hasContentBlocks ? this.renderContentBlocks(this.props.block.contentArea) : ""}
        </div>
      </div>
    )
  }
}
